// extracted by mini-css-extract-plugin
export default {"container":"ErrorFallback_container__Vx1+X"};